/**
 * Trim a string.
 */
export function normalize(value?: string) {
  return typeof value === 'string' ? value.trim() : '';
}

/**
 * Ensure an authorization header value includes the expected scheme.
 * Defaults to `Bearer` unless the header already starts with `Bearer` or `Basic`.
 */
export function normalizeAuthHeader(token: string) {
  const normalized = normalize(token);
  if (!normalized) {
    return '';
  }

  if (/^(Bearer|Basic)\s/i.test(normalized)) {
    return normalized;
  }

  return `Bearer ${normalized}`;
}
